import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Dashboard
export const getDashboard = async () => {
  const response = await axios.get(`${API}/dashboard`, { headers: getAuthHeaders() });
  return response.data;
};

// Providers
export const getProviders = async () => {
  const response = await axios.get(`${API}/providers`, { headers: getAuthHeaders() });
  return response.data;
};

export const createProvider = async (data) => {
  const response = await axios.post(`${API}/providers`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteProvider = async (id) => {
  const response = await axios.delete(`${API}/providers/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Entries
export const getEntries = async (forCalendar = false) => {
  const response = await axios.get(`${API}/entries?for_calendar=${forCalendar}`, { headers: getAuthHeaders() });
  return response.data;
};

export const createEntry = async (data, isManual = false) => {
  const response = await axios.post(`${API}/entries?is_manual=${isManual}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteEntry = async (id) => {
  const response = await axios.delete(`${API}/entries/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Requests
export const getRequests = async (forCalendar = false) => {
  const response = await axios.get(`${API}/requests?for_calendar=${forCalendar}`, { headers: getAuthHeaders() });
  return response.data;
};

export const createRequest = async (data) => {
  const response = await axios.post(`${API}/requests`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const approveRequest = async (id) => {
  const response = await axios.post(`${API}/requests/${id}/approve`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteRequest = async (id) => {
  const response = await axios.delete(`${API}/requests/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Utilities
export const calculateDays = async (startDate, endDate) => {
  const response = await axios.post(`${API}/calculate-days?start_date=${startDate}&end_date=${endDate}`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const checkConflicts = async (providerId, startDate, endDate) => {
  const response = await axios.get(`${API}/check-conflicts?provider_id=${providerId}&start_date=${startDate}&end_date=${endDate}`, { headers: getAuthHeaders() });
  return response.data;
};

// Auth - Change Password
export const changePassword = async (currentPassword, newPassword) => {
  const response = await axios.post(`${API}/auth/change-password`, {
    current_password: currentPassword,
    new_password: newPassword
  }, { headers: getAuthHeaders() });
  return response.data;
};

// Auth - Public Registration
export const registerPublic = async (data) => {
  const response = await axios.post(`${API}/auth/register-public`, data);
  return response.data;
};

// Auth - Forgot Password
export const forgotPassword = async (email) => {
  const response = await axios.post(`${API}/auth/forgot-password`, { email });
  return response.data;
};

// Auth - Reset Password
export const resetPassword = async (token, newPassword) => {
  const response = await axios.post(`${API}/auth/reset-password`, {
    token,
    new_password: newPassword
  });
  return response.data;
};

// Users - Pending approvals
export const getPendingUsers = async () => {
  const response = await axios.get(`${API}/users/pending`, { headers: getAuthHeaders() });
  return response.data;
};

export const approveUser = async (userId) => {
  const response = await axios.post(`${API}/users/${userId}/approve`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const rejectUser = async (userId) => {
  const response = await axios.delete(`${API}/users/${userId}/reject`, { headers: getAuthHeaders() });
  return response.data;
};

// My Stats - For partners to see their balance
export const getMyStats = async () => {
  const response = await axios.get(`${API}/my-stats`, { headers: getAuthHeaders() });
  return response.data;
};

// Seed
export const seedData = async () => {
  const response = await axios.post(`${API}/seed`);
  return response.data;
};
